<div class="container">
    <div class="section-title">
        <h2>Unser Fahrlehrer-Team</h2>
        <div class="bar"></div>
        <p>Unsere Fahrlehrer stehen dir mit Erfahrung, Geduld und Motivation zur Seite – für eine erfolgreiche und angenehme Führerscheinausbildung.</p>
    </div>

    <div class="row">
        <div class="col-md-6">
            <div class="single-team">
                <div class="image">
                    <!--img src="assets/img/team/team0.png" alt="image"-->

                    <ul class="social">
                        <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-instagram"></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                    </ul>

                    <div class="content">
                        <h3>Thomas Dayan</h3>
                        <p>Inhaber & Fahrlehrer (Klasse B/BE/B96)</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="single-team">
                <div class="image">
                    <!--img src="assets/img/team/team2.png" alt="image"-->

                    <ul class="social">
                        <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-instagram"></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                    </ul>

                    <div class="content">
                        <h3>Bahzet Yüsün</h3>
                        <p>Fahrlehrer (Klasse B/BE/B96)</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
